/**
 * Videos Database can be added here.
 * You can add videos of your wish with different attributes
 * */
import { chessbase, chessTalk, ericRosen, gothamChess } from "../../assets";

export const videos = [
  {
    _id: "Wo5dMEP_BbA",
    title: "Basic Opening Chess Trap | Budapest Gambit",
    videoLength: "10:29",
    youtubeID: "xfa3PXq2-sU",
    thumbnail: "http://i3.ytimg.com/vi/xfa3PXq2-sU/hqdefault.jpg",
    viewCount: "428k views",
    channelName: "Chessbase India",
    channelImg: chessbase,
    category: "Gambit",
  },
  {
    _id: "Wo5dMEP_BbP",
    title: "Learn the Stonewall Defense & Attack | 10-Minute Chess Openings",
    videoLength: "10:29",
    youtubeID: "4_brAnORWGw",
    thumbnail: "http://i3.ytimg.com/vi/4_brAnORWGw/hqdefault.jpg",
    viewCount: "149k views",
    channelName: "GothamChess",
    channelImg: gothamChess,
    category: "Opening",
  },
  {
    _id: "Wo5dMEP_BbQ",
    title: "Play the Sicilian Defense Opening like Beth Harmon",
    videoLength: "10:29",
    youtubeID: "65VWIFlc4C4",
    thumbnail: "http://i3.ytimg.com/vi/65VWIFlc4C4/hqdefault.jpg",
    viewCount: "545k views",
    channelName: "GothamChess",
    channelImg: gothamChess,
    category: "Opening",
  },
  {
    _id: "Wo5dMEP_BbD",
    title: "Basic Opening Chess Trap | Cochrane Gambit in the Petroff",
    videoLength: "10:29",
    youtubeID: "tqgoxsfHoK0",
    thumbnail: "http://i3.ytimg.com/vi/tqgoxsfHoK0/hqdefault.jpg",
    viewCount: "845k views",
    channelName: "Chessbase India",
    channelImg: chessbase,
    category: "Gambit",
  },
  {
    _id: "Wo5dMEP_BbE",
    title: "Bishop Endgames",
    videoLength: "10:29",
    youtubeID: "iznr0F-zY-4",
    thumbnail: "http://i3.ytimg.com/vi/iznr0F-zY-4/hqdefault.jpg",
    viewCount: "18k views",
    channelName: "Chessbase India",
    channelImg: chessbase,
    category: "Endgame",
  },
  {
    _id: "Wo5dMEP_BbF",
    title: "Parimarjan Negi's immortal against Svetushkin",
    videoLength: "10:29",
    youtubeID: "1ffXBrZnbyw",
    thumbnail: "http://i3.ytimg.com/vi/1ffXBrZnbyw/hqdefault.jpg",
    viewCount: "741k views",
    channelName: "Chessbase India",
    channelImg: chessbase,
    category: "Classic",
  },
  {
    _id: "Wo5dMEP_BbG",
    title: "Garry Kasparov vs Vishy Anand, 1995 | The Evans Gambit",
    videoLength: "10:29",
    youtubeID: "-r3aclHSNsw",
    thumbnail: "http://i3.ytimg.com/vi/-r3aclHSNsw/hqdefault.jpg",
    viewCount: "329k views",
    channelName: "Chessbase India",
    channelImg: chessbase,
    category: "Classic",
  },
  {
    _id: "Wo5dMEP_BbM",
    title: "Queen vs Pawn Endgame",
    videoLength: "10:29",
    youtubeID: "2q-TjB6YYRI",
    thumbnail: "http://i3.ytimg.com/vi/2q-TjB6YYRI/hqdefault.jpg",
    viewCount: "248k views",
    channelName: "GothamChess",
    channelImg: gothamChess,
    category: "Endgame",
  },
  {
    _id: "Wo5dMEP_BbN",
    title: "Rook & Pawn Endgame",
    videoLength: "10:29",
    youtubeID: "JMZJ9P2Hnq0",
    thumbnail: "http://i3.ytimg.com/vi/JMZJ9P2Hnq0/hqdefault.jpg",
    viewCount: "245k views",
    channelName: "GothamChess",
    channelImg: gothamChess,
    category: "Endgame",
  },
  {
    _id: "Wo5dMEP_BbJ",
    title: "Rook vs Pawns Endgame",
    videoLength: "10:29",
    youtubeID: "mZquhq8Nz94",
    thumbnail: "http://i3.ytimg.com/vi/mZquhq8Nz94/hqdefault.jpg",
    viewCount: "129k views",
    channelName: "Chessbase India",
    channelImg: chessbase,
    category: "Endgame",
  },
  {
    _id: "Wo5dMEP_BbK",
    title: "Rook + Bishop vs Rook II + Bishop & Knight mate",
    videoLength: "10:29",
    youtubeID: "yzasukqyE1I",
    thumbnail: "http://i3.ytimg.com/vi/yzasukqyE1I/hqdefault.jpg",
    viewCount: "443k views",
    channelName: "Chessbase India",
    channelImg: chessbase,
    category: "Endgame",
  },
  {
    _id: "Wo5dMEP_BbL",
    title: "King & Pawn Endgame",
    videoLength: "10:29",
    youtubeID: "mCsc24k-Q8M",
    thumbnail: "http://i3.ytimg.com/vi/mCsc24k-Q8M/hqdefault.jpg",
    viewCount: "549k views",
    channelName: "GothamChess",
    channelImg: gothamChess,
    category: "Endgame",
  },
  {
    _id: "Wo5dMEP_BbH",
    title: "Kramnik's immortal against Gelfand, 1996",
    videoLength: "10:29",
    youtubeID: "Gjoxxg0c4MA",
    thumbnail: "http://i3.ytimg.com/vi/Gjoxxg0c4MA/hqdefault.jpg",
    viewCount: "143k views",
    channelName: "Chessbase India",
    channelImg: chessbase,
    category: "Classic",
  },
  {
    _id: "Wo5dMEP_BbI",
    title: "Vidit Gujrathi's immortal against Vladimir Kramnik",
    videoLength: "10:29",
    youtubeID: "OTRnnUPcZCE",
    thumbnail: "http://i3.ytimg.com/vi/OTRnnUPcZCE/hqdefault.jpg",
    viewCount: "178k views",
    channelName: "Chessbase India",
    channelImg: chessbase,
    category: "Classic",
  },
  {
    _id: "Wo5dMEP_BbO",
    title: "Learn the Caro-Kann Defense | 10-Minute Chess Openings",
    videoLength: "10:29",
    youtubeID: "rmbU97iftC8",
    thumbnail: "http://i3.ytimg.com/vi/rmbU97iftC8/hqdefault.jpg",
    viewCount: "485k views",
    channelName: "GothamChess",
    channelImg: gothamChess,
    category: "Opening",
  },
  {
    _id: "Wo5dMEP_BbB",
    title: "Basic Opening Chess Trap | Sicilian Defence | Morra Gambit",
    videoLength: "10:29",
    youtubeID: "geJfIY2DhcA",
    thumbnail: "http://i3.ytimg.com/vi/geJfIY2DhcA/hqdefault.jpg",
    viewCount: "387k views",
    channelName: "Chessbase India",
    channelImg: chessbase,
    category: "Gambit",
  },
  {
    _id: "Wo5dMEP_BbC",
    title: "Basic Opening Chess Trap | Danish Gambit | Free Queen or not?",
    videoLength: "10:29",
    youtubeID: "5SYR4oThgh8",
    thumbnail: "http://i3.ytimg.com/vi/5SYR4oThgh8/hqdefault.jpg",
    viewCount: "24k views",
    channelName: "Chessbase India",
    channelImg: chessbase,
    category: "Gambit",
  },
  {
    _id: "Wo5dMEP_BbR",
    title: "WIN IN 8 MOVES | The Fried Liver Attack Opening",
    videoLength: "10:29",
    youtubeID: "va0s92praEM",
    thumbnail: "http://i3.ytimg.com/vi/hLFSufXxtuI/hqdefault.jpg",
    viewCount: "349k views",
    channelName: "GothamChess",
    channelImg: gothamChess,
    category: "Opening",
  },
  {
    _id: "Wo5dMEP_BbS",
    title: "Trapping a Grandmaster in 7 Moves | Stafford Gambit",
    videoLength: "10:29",
    youtubeID: "ztOW6VZlrxQ",
    thumbnail: "http://i3.ytimg.com/vi/ztOW6VZlrxQ/hqdefault.jpg",
    viewCount: "445k views",
    channelName: "Eric Rosen",
    channelImg: ericRosen,
    category: "Gambit",
  },
  {
    _id: "Wo5dMEP_BbT",
    title: "Mikhail Tal's Greatest Queen Sacrifice! Best Chess Games",
    videoLength: "10:29",
    youtubeID: "vBhnjG-sIRU",
    thumbnail: "http://i3.ytimg.com/vi/vBhnjG-sIRU/hqdefault.jpg",
    viewCount: "97k views",
    channelName: "Chess Talk",
    channelImg: chessTalk,
    category: "Classic",
  },
  {
    _id: "Wo5dMEP_BbU",
    title:
      "MIND-BLOWING GAME || Magnus Carlsen vs Ian Nepomniachtchi || FIDE World Chess Championship 2021",
    videoLength: "10:29",
    youtubeID: "RtKPc-e9tUw",
    thumbnail: "http://i3.ytimg.com/vi/RtKPc-e9tUw/hqdefault.jpg",
    viewCount: "125k views",
    channelName: "Chess Talk",
    channelImg: chessTalk,
    category: "Classic",
  },
  {
    _id: "Wo5dMEP_BbV",
    title:
      "Bobby Fischer’s Best Chess Game Ever! | Fischer vs R. Byrne - US, 1963 | The Brilliancy Prize",
    videoLength: "10:29",
    youtubeID: "EMDJebpc4oQ",
    thumbnail: "http://i3.ytimg.com/vi/EMDJebpc4oQ/hqdefault.jpg",
    viewCount: "245k views",
    channelName: "Chess Talk",
    channelImg: chessTalk,
    category: "Classic",
  },
  {
    _id: "Wo5bacEP_BbV",
    title: "How to Solve Chess Tactics | 1200-1400 Puzzles Training",
    videoLength: "17:28",
    youtubeID: "D3uEIk9_RYg",
    thumbnail: "http://i3.ytimg.com/vi/D3uEIk9_RYg/hqdefault.jpg",
    viewCount: "123k views",
    channelName: "GothamChess",
    channelImg: gothamChess,
    category: "Tactics",
  },
  {
    _id: "Wo5abcdEP_BbV",
    title: "How to Solve Chess Tactics | 1400-1600 Puzzles Training",
    videoLength: "17:26",
    youtubeID: "t-MMTNk98bU",
    thumbnail: "http://i3.ytimg.com/vi/t-MMTNk98bU/hqdefault.jpg",
    viewCount: "64k views",
    channelName: "GothamChess",
    channelImg: gothamChess,
    category: "Tactics",
  },
  {
    _id: "Wo5cdEP_BbV",
    title: "How to Solve Chess Tactics | 1600-1800 Puzzles Training",
    videoLength: "17:25",
    youtubeID: "zGXzi4jGUTA",
    thumbnail: "http://i3.ytimg.com/vi/zGXzi4jGUTA/hqdefault.jpg",
    viewCount: "59k views",
    channelName: "GothamChess",
    channelImg: gothamChess,
    category: "Tactics",
  },
  {
    _id: "Wo5cdabEP_BbV",
    title: "How to Solve Chess Tactics | 1800-2000 Puzzles Training",
    videoLength: "14:25",
    youtubeID: "jimpI-LoLjI",
    thumbnail: "http://i3.ytimg.com/vi/jimpI-LoLjI/hqdefault.jpg",
    viewCount: "37k views",
    channelName: "GothamChess",
    channelImg: gothamChess,
    category: "Tactics",
  },
  {
    _id: "Wo7cdabEP_BbV",
    title: "How to Solve Chess Tactics | 2000-2200 Puzzles Training",
    videoLength: "17:22",
    youtubeID: "u0o38cEaGdw",
    thumbnail: "http://i3.ytimg.com/vi/u0o38cEaGdw/hqdefault.jpg",
    viewCount: "53k views",
    channelName: "GothamChess",
    channelImg: gothamChess,
    category: "Tactics",
  },
  {
    _id: "Wo8cdabEP_BbV",
    title: "How To Solve Chess Puzzles | Improve Your Tactics & Visualization",
    videoLength: "34:48",
    youtubeID: "LWzltpXk2mg",
    thumbnail: "http://i3.ytimg.com/vi/LWzltpXk2mg/hqdefault.jpg",
    viewCount: "359k views",
    channelName: "GothamChess",
    channelImg: gothamChess,
    category: "Tactics",
  },
  {
    _id: "Wo9cdabEP_BbV",
    title:
      "Learn Chess Notation - The Language of Chess! How to Read & Write Chess Moves! Basics for Beginners",
    videoLength: "11:21",
    youtubeID: "b6PR885Rgb8",
    thumbnail: "http://i3.ytimg.com/vi/b6PR885Rgb8/hqdefault.jpg",
    viewCount: "329k views",
    channelName: "Chess Talk",
    channelImg: chessTalk,
    category: "Tutorials",
  },
  {
    _id: "Wo10cdabEP_BbV",
    title:
      "Top 32 Checkmates You Must Know | Basic Mating Patterns, Chess Tactics, Moves & Ideas to Win",
    videoLength: "19:45",
    youtubeID: "EAHhI6IXdts",
    thumbnail: "http://i3.ytimg.com/vi/EAHhI6IXdts/hqdefault.jpg",
    viewCount: "587k views",
    channelName: "Chess Talk",
    channelImg: chessTalk,
    category: "Tutorials",
  },
  {
    _id: "Wo11cdabEP_BbV",
    title:
      "ALL Chess Tactics Explained |Chess Strategy, Moves, Ideas & Basics for Beginners| How to Play Chess",
    videoLength: "15:46",
    youtubeID: "E4F77emUnqQ",
    thumbnail: "http://i3.ytimg.com/vi/E4F77emUnqQ/hqdefault.jpg",
    viewCount: "879k views",
    channelName: "Chess Talk",
    channelImg: chessTalk,
    category: "Tutorials",
  },
  {
    _id: "Wo12cdabEP_BbV",
    title:
      "How to Get Better at CHESS? | Chess Improvement Tips & Training Plan to Increase Your Rating & Win",
    videoLength: "10:29",
    youtubeID: "Cx4LV2kxCRY",
    thumbnail: "http://i3.ytimg.com/vi/Cx4LV2kxCRY/hqdefault.jpg",
    viewCount: "237k views",
    channelName: "Chess Talk",
    channelImg: chessTalk,
    category: "Tutorials",
  },
  {
    _id: "Wo13cdabEP_BbV",
    title:
      "Chess Masterclass: 5 Step Thinking Strategy | Best Tips, Tactics, Moves & Ideas for Beginners",
    videoLength: "10:35",
    youtubeID: "2y_jUGO5agg",
    thumbnail: "http://i3.ytimg.com/vi/2y_jUGO5agg/hqdefault.jpg",
    viewCount: "989k views",
    channelName: "Chess Talk",
    channelImg: chessTalk,
    category: "Tutorials",
  },
  {
    _id: "Wo14cdabEP_BbV",
    title:
      "How to Play Chess: Rules for Beginners: Learn Game Basics, Board Setup, Moves, Castling, En Passant",
    videoLength: "11:35",
    youtubeID: "mGuYHXfgDxY",
    thumbnail: "http://i3.ytimg.com/vi/mGuYHXfgDxY/hqdefault.jpg",
    viewCount: "987k views",
    channelName: "Chess Talk",
    channelImg: chessTalk,
    category: "Tutorials",
  },
  {
    _id: "Wo15cdabEP_BbV",
    title:
      "Chess Masterclass: 5 Step Thinking Strategy | Best Tips, Tactics, Moves & Ideas for Beginners",
    videoLength: "10:35",
    youtubeID: "2y_jUGO5agg",
    thumbnail: "http://i3.ytimg.com/vi/2y_jUGO5agg/hqdefault.jpg",
    viewCount: "995k views",
    channelName: "Chess Talk",
    channelImg: chessTalk,
    category: "Tutorials",
  },
  {
    _id: "Wo24cdabEP_BbV",
    title:
      "Chess Masterclass: 5 Step Thinking Strategy | Best Tips, Tactics, Moves & Ideas for Beginners",
    videoLength: "10:35",
    youtubeID: "2y_jUGO5agg",
    thumbnail: "http://i3.ytimg.com/vi/2y_jUGO5agg/hqdefault.jpg",
    viewCount: "995k views",
    channelName: "Chess Talk",
    channelImg: chessTalk,
    category: "Tutorials",
  },
  {
    _id: "Wo16cdabEP_BbV",
    title:
      "MATE in 12 | Chess Challenge | Solve This If YOU Are a GENIUS | Endgame Puzzle, Moves & Tactics",
    videoLength: "05:08",
    youtubeID: "FN8hVAV20hQ",
    thumbnail: "http://i3.ytimg.com/vi/FN8hVAV20hQ/hqdefault.jpg",
    viewCount: "235k views",
    channelName: "Chess Talk",
    channelImg: chessTalk,
    category: "Puzzles",
  },
  {
    _id: "Wo17cdabEP_BbV",
    title:
      "Chess Challenge | Solve This If YOU Can | Chess Endgame Puzzle, Tactics, Moves & Ideas",
    videoLength: "03:45",
    youtubeID: "GBtFQPtxG6A",
    thumbnail: "http://i3.ytimg.com/vi/FN8hVAV20hQ/hqdefault.jpg",
    viewCount: "695k views",
    channelName: "Chess Talk",
    channelImg: chessTalk,
    category: "Puzzles",
  },
  {
    _id: "Wo18cdabEP_BbV",
    title:
      "Solve This If YOU Are a GENIUS | Chess Challenge | Endgame Puzzle, Moves, Ideas, Strategy & Tactics",
    videoLength: "05:54",
    youtubeID: "WqenJgw7ZIc",
    thumbnail: "http://i3.ytimg.com/vi/FN8hVAV20hQ/hqdefault.jpg",
    viewCount: "975k views",
    channelName: "Chess Talk",
    channelImg: chessTalk,
    category: "Puzzles",
  },
  {
    _id: "Wo19cdabEP_BbV",
    title:
      "A Puzzle That Engines Can't Solve! Are YOU Better than Stockfish? Best Chess Moves, Tactics & Ideas",
    videoLength: "03:50",
    youtubeID: "ecJoVMPbVpI",
    thumbnail: "http://i3.ytimg.com/vi/ecJoVMPbVpI/hqdefault.jpg",
    viewCount: "123k views",
    channelName: "Chess Talk",
    channelImg: chessTalk,
    category: "Puzzles",
  },
  {
    _id: "Wo20cdabEP_BbV",
    title: "Can YOU Solve this Tricky 'MATE IN ONE' Puzzle?",
    videoLength: "00:57",
    youtubeID: "sniw4pN6bDQ",
    thumbnail: "http://i3.ytimg.com/vi/ecJoVMPbVpI/hqdefault.jpg",
    viewCount: "401k views",
    channelName: "Chess Talk",
    channelImg: chessTalk,
    category: "Puzzles",
  },
  {
    _id: "Wo21cdabEP_BbV",
    title:
      "Can You Play Like a Grandmaster? Let's See! Bobby Fischer's Best Chess Games, Moves, Tactics, Ideas",
    videoLength: "06:58",
    youtubeID: "JWNlzP2fpsw",
    thumbnail: "http://i3.ytimg.com/vi/JWNlzP2fpsw/hqdefault.jpg",
    viewCount: "622k views",
    channelName: "Chess Talk",
    channelImg: chessTalk,
    category: "Puzzles",
  },
];
